import { useEffect, useState } from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";

// Fallback used when the Firestore collection is empty / unavailable
// (e.g. on first load before docs are seeded, or while offline).
const DEFAULT_OPTIONS = ["Clear", "Slightly Stained", "Stained", "Muddy"];

/**
 * Subscribes to the `waterClarityOptions` Firestore collection.
 *
 * Each doc is expected to look like:
 *   { label: "Clear", order: 1, active: true }
 *
 * Docs with active === false are filtered out. Results are sorted by
 * the numeric `order` field (falling back to label order).
 *
 * Returns an array of label strings ready to render in a <select>.
 */
export default function useWaterClarityOptions() {
  const [options, setOptions] = useState(DEFAULT_OPTIONS);

  useEffect(() => {
    let cancelled = false;
    const q = query(collection(db, "waterClarityOptions"), orderBy("order", "asc"));
    const unsub = onSnapshot(
      q,
      (snap) => {
        if (cancelled) return;
        const labels = snap.docs
          .map((d) => d.data() || {})
          .filter((data) => data.active !== false)
          .map((data) => String(data.label || "").trim())
          .filter(Boolean);
        setOptions(labels.length > 0 ? labels : DEFAULT_OPTIONS);
      },
      (err) => {
        console.warn("[useWaterClarityOptions] snapshot error:", err);
        if (!cancelled) setOptions(DEFAULT_OPTIONS);
      }
    );
    return () => {
      cancelled = true;
      unsub();
    };
  }, []);

  return options;
}

export { DEFAULT_OPTIONS as DEFAULT_WATER_CLARITY_OPTIONS };
